import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoriesItem, PointOfInterest } from '../categories/categories.model';
import { NodeService } from '../../services/node-service/node-service.service';
import { RootcategoriesService } from '../rootcategories/rootcategories.service';
import { Subscription } from 'rxjs';
import { SubcategoryService } from '../subcategory/subcategory.service';

@Component({
  selector: 'app-points-of-interest',
  templateUrl: './points-of-interest.component.html',
  styleUrls: ['./points-of-interest.component.css'],
  standalone: false,
})
export class PointsOfInterestComponent implements OnInit, OnDestroy {
  id: number = 0;
  parent!: CategoriesItem;
  pois!: PointOfInterest[];
  categoryId: number = 0;
  subcription!: Subscription;
  subcriptionData!: Subscription;
  subscriptionDataPois!: Subscription;
  displayedColumns = ['id', 'nombre', 'actions'];
  viewTitle: string = 'Categoría hija';
  isPois: boolean = false;

  constructor(
    public route: ActivatedRoute,
    private nodeService: NodeService,
    private subCategoryService: SubcategoryService,
    private rootCategoriesService: RootcategoriesService
  ) {}

  ngOnInit(): void {
    this.subcription = this.route.params.subscribe((params) => {
      this.categoryId = parseInt(params['chId'], 10);

      this.subscriptionDataPois = this.subCategoryService
        .getCategory(this.categoryId)
        .subscribe(({ body }) => {
          if (body.label === 'pois') {
            this.viewTitle = 'Puntos de interés';
            this.isPois = true;
            return this.nodeService.setPois(body.data);
          }
        });

      this.nodeService.setChildCategoryId(this.categoryId);

      const parentId = this.nodeService.getSubCategoryId();
      const categories = this.nodeService.getChildCategories();

      if (categories.length <= 0) {
        this.subcriptionData = this.subCategoryService.getCategory(parentId).subscribe({
          next: ({ body }) => {
            const data = body.body;
            this.nodeService.setChildCategories(data);
            this.parent = data.filter(
              (category: CategoriesItem) => category.id === this.categoryId
            )[0];
          },
          error: () => {
            this.rootCategoriesService.openSnacBar('Ha ocurrido un error');
          },
        });
      } else {
        this.parent = categories.filter(
          (category: CategoriesItem) => category.id === this.categoryId
        )[0];
      }
    });
  }

  ngOnDestroy(): void {
    this.subcription?.unsubscribe();
    this.subcriptionData?.unsubscribe();
    this.subscriptionDataPois?.unsubscribe();
  }
}
